module.exports = __webpack_public_path__ + "img/PhonePlan-Icon.29e2b8b0.svg";